import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loadingCsv: false,
  uploadCsvSuccess: false,
  errorCsv: null,
}

const slice = createSlice({
  name: 'uploadCSV',
  initialState: initialState,
  reducers: {
    uploadCsvAction: (state, action) => {
      state.loadingCsv = true
      state.errorCsv = null
    },
    uploadCsvSuccessAction:(state)=>{
      state.loadingCsv = false
      state.uploadCsvSuccess = true
      state.errorCsv = null
    },
    uploadCsvErrorAction: (state, action) => {
      state.loadingCsv = false
      state.uploadCsvSuccess = false
      state.errorCsv = action.payload
    },
    uploadCsvResetState: () => initialState,
  },
});

export const {
  uploadCsvAction,
  uploadCsvSuccessAction,
  uploadCsvErrorAction,
  uploadCsvResetState
} = slice.actions

export default slice.reducer
